import { useEffect } from 'react';
import useBodyClass from '../../hooks/useBodyClass';
import useDlogLoginFunnel from '../../hooks/useDlogLoginFunnel';

export default function Splash() {
  useBodyClass('splash');
  const dlog = useDlogLoginFunnel();

  useEffect(() => {
    dlog({
      phase: 'Studio_Splash',
      action: 'Render',
    });
  }, [dlog]);

  return (
    <div className="splash__container">
      <img src="https://prod.cdni.callofduty.com/prelogin/media/splash.jpg" alt="splash" />
    </div>
  );
}
